<template>
  <!-- 资金支付过程台账 -->
  <div
    class="contain wageLedger"
    style="padding: 1vh; width: 100%; height: 100%"
  >
    <el-row style="height: 3vh; padding-left: 0.5vw; padding-top: 0.1vh">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>智慧表单</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="box-body">
      <div class="box-left">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            highlight-current
             node-key="entId"
            @node-click="handleNodeClick"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          ></el-tree>
      </div>
      <div class="box" style="overflow: auto">
        <div class="build-bar" style="font-size: 1vw">
          <span> 智慧表单信息</span>
          <div>
           <span>合同价：</span>
           <el-input style="width:6vw;" v-model="money.cashContract" type="number"></el-input>
           <span style="margin-left:2vw;">初审价：</span>
           <el-input style="width:6vw;" type="number" v-model="money.beginningAppraisal"></el-input>
           <span style="margin-left:2vw;">终审价：</span>
           <el-input style="width:6vw;" type="number" v-model="money.endAppraisal"></el-input>
           <el-button type="primary" style="margin-left:3vw;" @click="saveMoney">编辑</el-button>
          </div>
          <el-button type="success" icon="el-icon-plus" @click="addQin"
            >添加</el-button
          >
        </div>

        <!-- <div class="build-bar" style="justify-content: space-between;">
        <div style="display:flex;align-items:center;width: 16vw;">
            <p style="display: flex;align-items: center;margin-right:1vw;">总产值：<span v-if="isTotal">{{totalValue_view}}</span><el-input v-model="total" v-else style="width:8vw;margin-right:0.5vw;"></el-input> 万</p>
        </div>
        <div style="display:flex;justify-content: space-between;align-items:center;width:30%">
            <el-date-picker
                v-model="year"
                @change="doFilter"
                type="year"
                value-format="yyyy"
                placeholder="选择年"
                style="margin:auto;width:130px;font-size:12px"
            ></el-date-picker>
        </div>
        <el-button v-if="totalValue_view" type="success" icon="el-icon-plus" @click="addQin">添加</el-button>
      </div> -->
        <div class="box-content">
          <el-table
            :data="listData"
            border
            stripe
            height="100%"
            style="width: 100%"
          >
            <template slot="empty">
              <p>{{ dataText }}</p>
            </template>
            <el-table-column
              label="序号"
              width="60"
              type="index"
            ></el-table-column>
            <el-table-column label="时间">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-select v-model="master.month">
                    <el-option
                      v-for="item in groups3"
                      :key="item.getTime"
                      :label="item.getTime"
                      :value="item.getTime"
                    ></el-option>
                  </el-select>
                </span>
                <span v-else>{{ scope.row.month }}</span>
                <!-- <span>{{ scope.row.month }}</span> -->
              </template>
            </el-table-column>
            <el-table-column label="本月支付金额(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input
                    size="mini"
                    placeholder="请输入内容"
                    @input="getValue"
                    v-model="master.nowMonthPay"
                  ></el-input>
                </span>
                <span v-else>{{ scope.row.nowMonthPay }}</span>
              </template>
            </el-table-column>
            <el-table-column label="累计支付金额(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input
                    size="mini"
                    placeholder="累计支付金额"
                    v-model="master.totalMonthPay"
                    disabled
                  ></el-input>
                </span>
                <span v-else>{{ scope.row.totalMonthPay }}</span>
              </template>
            </el-table-column>
            <el-table-column label="支付农民工工资(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input
                    size="mini"
                    placeholder="支付农民工工资"
                    v-model="master.nowMonthPaySalary"
                  ></el-input>
                </span>
                <span v-else>{{ scope.row.nowMonthPaySalary }}</span>
              </template>
            </el-table-column>
            <el-table-column label="累计支付工资(万元)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input
                    size="mini"
                    placeholder="累计支付工资"
                    v-model="master.totalMonthPaySalary"
                    disabled
                  ></el-input>
                </span>
                <span v-else>{{ scope.row.totalMonthPaySalary }}</span>
              </template>
            </el-table-column>
            <el-table-column label="本月投资进度(%)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input
                    size="mini"
                    placeholder="本月投资进度"
                    v-model="master.nowMonthInvestment"
                  ></el-input>
                </span>
                <span v-else>{{ scope.row.nowMonthInvestment }}</span>
              </template>
            </el-table-column>
            <el-table-column label="累计投资进度(%)">
              <template slot-scope="scope">
                <span v-if="scope.row.isSet">
                  <el-input
                    size="mini"
                    placeholder="本月投资进度"
                    v-model="master.totalMonthInvestment"
                    disabled
                  ></el-input>
                </span>
                <span v-else>{{ scope.row.totalMonthInvestment }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="备注">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-input size="mini" placeholder="请输入内容" v-model="master.remark"></el-input>
              </span>
              <span v-else>{{ scope.row.remark }}</span>
            </template>
          </el-table-column> -->
            <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <span
                class="el-tag el-tag--info el-tag--mini"
                style="cursor: pointer;margin-right: 10px;"
                @click="pwdChange(scope.row,scope.$index,true)"
              >{{scope.row.isSet?'保存':"修改"}}</span>
                <span
                v-if="scope.row.isSet"
                class="el-tag el-tag--info el-tag--mini"
                style="cursor: pointer;margin-right: 10px;"
                @click="pwdChange(scope.row,scope.$index,true)"
              >保存</span>
                  <span
                class="el-tag el-tag--info el-tag--mini"
                style="cursor: pointer;margin-right: 10px;"
                @click="pwdChange(scope.row,scope.$index,true)"
              >修改</span>
              <span  @click="delChange(scope.row,scope.$index,true)"   class="el-tag el-tag--danger el-tag--mini" style="cursor: pointer;">
                                删除
              </span>
              <span
                v-if="scope.row.isSet"
                class="el-tag el-tag--mini"
                style="cursor: pointer;"
                @click="pwdChange(scope.row,scope.$index,false)"
              >取消</span>
            </template>
          </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  class="el-tag el-tag--info el-tag--mini"
                  style="cursor: pointer; margin-right: 10px"
                  @click="pwdChange(scope.row, scope.$index, true)"
                  >{{ scope.row.isSet ? '保存' : '修改' }}</span
                >
                <span
                  @click="delChange(scope.row, scope.$index, true)"
                  v-if="!scope.row.isSet"
                  class="el-tag el-tag--danger el-tag--mini"
                  style="cursor: pointer"
                  >删除</span
                >
                <span
                  v-if="scope.row.isSet"
                  class="el-tag el-tag--mini"
                  style="cursor: pointer"
                  @click="pwdChange(scope.row, scope.$index, false)"
                  >取消</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[3, 5, 10, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      // search:{
      //     applyMonth:util.myTime.getCurMonth(),
      // },
      listData: [],
      groupId: '',
      // num:{
      //     money:0,
      //     person:0
      // },
      uploadUrl: myHttp.importExcelEPM, //上传地址
      uploadHead: {
        accessToken: this.$store.state.token,
      },
      uploadData: {
        entProjectId: '',
        attachmentTypeId: '',
        userId: util.session.get('user').id,
      },
      uploadUrl1: base.url + '/upload/uploadPhoto', //上传付款评依地址
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      dataText: '数据加载中...',
      entProjectId: '',
      attachmentTypeId: '',
      master: {
        id: '',
        month: '',
        projectId: '',
        nowMonthInvestment: '', //Y 本月投资进度
        nowMonthPay: '', //Y 本月支付金额
        nowMonthPaySalary: '', //Y 支付农民工工资
      },
      isAddFlag: false,
      proType: [],
      type: '',
      chooseDate: util.myTime.getCurTime(),
      projectId: '',
      projectName: '',
      name: '',
      year: '', // 年
      groups3: [
        {
          getTime: new Date().getFullYear() + '-' + '01',
        },
        {
          getTime: new Date().getFullYear() + '-' + '02',
        },
        {
          getTime: new Date().getFullYear() + '-' + '03',
        },
        {
          getTime: new Date().getFullYear() + '-' + '04',
        },
        {
          getTime: new Date().getFullYear() + '-' + '05',
        },
        {
          getTime: new Date().getFullYear() + '-' + '06',
        },
        {
          getTime: new Date().getFullYear() + '-' + '07',
        },
        {
          getTime: new Date().getFullYear() + '-' + '08',
        },
        {
          getTime: new Date().getFullYear() + '-' + '09',
        },
        {
          getTime: new Date().getFullYear() + '-' + '10',
        },
        {
          getTime: new Date().getFullYear() + '-' + '11',
        },
        {
          getTime: new Date().getFullYear() + '-' + '12',
        },
      ],
      getTime: '', //当前
      joinType: '2',
      projects: [],
      searchPro: [], //搜索的
      total: 2000,
      isTotal: true,
      entId: '',
      totalValue_view: '',
      dataTree: [], //树形列表
      defaultProps: {
        children: 'children',
        label: 'entName'
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      //金额价
            money:{
                cashContract:0,  //合同价
                beginningAppraisal:0,  //初审价
                endAppraisal:0,   //终审价
            },
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
    this.uploadData.entProjectId = this.$route.params.id
    this.uploadData.attachmentTypeId = this.$route.params.type
    this.entProjectId = this.$route.params.id
    this.attachmentTypeId = this.$route.params.type
    // this.getData()
    this.getdataTree()
    // this.getAll()
    // this.getMoney()
  },
  methods: {
    // dataTree
    getdataTree(){
         var that = this
        myHttp
          .getListByprojectEnt({
            projectId:this.groupId
          })
          .then(function(resp) {
            if (resp.data.code == '200') {
              that.dataTree = resp.data.data.projectEnt
              if (that.dataTree.length > 0) {
              that.entId =that.dataTree[0].entId
              that.currentNodekey = that.dataTree[0].entId
              that.expandedkeys.push(that.dataTree[0].entId)
              that.$nextTick(() => {
                // treeBox 元素的ref   value 绑定的node-key
                // setTimeout(function(){
               that.$refs.tree.setCurrentKey(that.currentNodekey)
              // },100)
              that.getData()
              })
            }
            }
          })
    },
    doFilter() {
      // this.uploadData.applyMonth = this.search.applyMonth
      this.getData()
    },
    //  handleSizeChange(val) {
    //     this.pageSize = val
    //     this.handleCurrentChange(this.currentPage)
    // },
    // handleCurrentChange(val) {
    //     this.currentPage = val
    //     this.currentChangePage();
    // },
    // // 监控当前页码
    // currentChangePage(list) {
    //     this.getData();
    // },
    //点击过滤
    showProjectFun(index) {
      this.search.unit = index
      this.getData()
      // this.getAllNum()
    },
    //获取所有项目
    // getAll() {
    //  console.log(111)
    //   var that = this
    //   myHttp
    //     .getProjectListByEntIdAndJoinType({
    //       entId: this.groupId,
    //       joinType: this.joinType
    //     })
    //     .then(function(resp) {
    //       if (resp.data.code == '200') {
    //         var list = resp.data.data.list || []
    //         that.projects = list,
    //         that.searchPro =list
    //       }
    //     })
    // },
    //获取数据
    getData() {
      var that = this
      myHttp
        .getWisdomFormPage({
          entId:this.entId,
          projectId: this.groupId,
          pageSize: this.pageSize,
          pageNum: this.currentPage,
          // projectName:this.projectName
        })
        .then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.wisdomFormPageInfo.list || []
            // var num = {money:0,person:list.length};
            for (var i = 0; i < list.length; i++) {
              // list[i].bilv =
              //   list[i].planPrepaidMoney && list[i].planPrepaidMoney != 0? ((parseFloat(list[i].prepaidMoney) /parseFloat(list[i].planPrepaidMoney)) *100).toFixed(2) : 0
              //   list[i].paymentVoucher =list[i].paymentVoucher && '' != list[i].paymentVoucher? base.httpCtx + list[i].paymentVoucher  : ''
              //    if ('' != list[i].paymentVoucher) {
              //   list[i].paymentVouchers = []
              //   list[i].paymentVouchers.push(list[i].paymentVoucher)
              // }
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].isSet = false
            }
            // num.money = num.money.toFixed(2);
            that.listData = list

            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
            that.totalItems = resp.data.data.wisdomFormPageInfo.total || 0
          } else {
            that.dataText = '暂无数据'
          }
          that.money={
             cashContract:0,  //合同价
                beginningAppraisal:0,  //初审价
                endAppraisal:0,   //终审价
          }
          that.getMoney()
        })
    },

    //导出
    // exportOut() {
    //   var token = this.$store.state.token
    //   window.open(
    //     myHttp.downloadEntProjectMoney +
    //       '?entProjectId=' +
    //       this.entProjectId +
    //       '&attachmentTypeId=' +
    //       this.attachmentTypeId +
    //       '&accessToken=' +
    //       token
    //   )
    // },
    //提交
    subWage() {
      // var that = this
      // var applyFormId = that.listData[0].applyFormId
      // myHttp.commitSalaryApply({
      //     applyMonth:this.search.applyMonth,
      //     projectId:this.groupId,
      //     applyFormId:applyFormId,
      //     userId:util.session.get('user').id
      // }).then(function(resp){
      //     if(resp.data.code=='200'){
      //         that.$router.go(-1);
      //         that.$message.success('提交成功');
      //     }else{
      //         that.$message.error(resp.data.msg);
      //     }
      // })
    },

    //添加
    addQin() {
      if (this.isAddFlag) {
        this.$message.warning('请先保存当前台账')
        return
      } else if (this.master.id != '') {
        this.$message.warning('请先保存当前编辑项')
        return
      }
      this.isAddFlag = true
      this.master = {
        id: '',
        month: '',
        projectId: '',
        nowMonthInvestment: '', //Y 本月投资进度
        nowMonthPay: '', //Y 本月支付金额
        nowMonthPaySalary: '',
        isSet: true,
      }
      this.master.month = util.myTime.getCurMonth()

      this.listData.unshift(this.master)
    },

    //修改
    pwdChange(row, index, cg) {
      //点击修改 判断是否已经保存所有操作
      var that = this
      //for (let i of this.master) {
      if (
        (this.master.id != '' && this.master.id != row.id) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
      //}
      //是否是取消操作
      if (!cg) {
        //if (!app.master_user.sel.id) app.master_user.data.splice(index, 1);
        this.getData()
        this.master = {
          id: '',
          month: '',
          projectId: '',
          nowMonthInvestment: '', //Y 本月投资进度
          nowMonthPay: '', //Y 本月支付金额
          nowMonthPaySalary: '',
        }
        this.isAddFlag = false
        return (row.isSet = !row.isSet)
      }
      //提交数据
      if (row.isSet) {
        //项目请求操作
        var that = this
        // if (
        //   this.master.prepaidMoney != '' &&
        //   this.master.planPrepaidMoney != ''
        // ) {
        //   this.master.bilv = (
        //     (parseFloat(this.master.prepaidMoney) /
        //       parseFloat(this.master.planPrepaidMoney)) *
        //     100
        //   ).toFixed(2)
        // }
        this.master.entId = this.entId
        this.master.projectId = this.groupId
        this.master.createBy = util.session.get('user').id
        if (this.master.id == '') {
          //   if(that.listData.length==1){
          //   that.master.cumulativePay = parseInt(that.master.monthPay)
          // }else if(that.listData.length==2){
          //   for(var i= 0;i<that.listData.length;i++){
          //     console.log(that.listData)
          //   // console.log(that.listData[that.listData.length-2].cumulativePay)
          //   that.master.cumulativePay  =parseInt(that.listData[that.listData.length-1].cumulativePay)  + parseInt(that.master.monthPay)
          //   }
          // }else{
          // that.master.cumulativePay  =parseInt(that.listData[1].cumulativePay)  + parseInt(that.master.monthPay)
          // }
          myHttp.createOrUpdateWis(this.master).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加成功')
              that.isAddFlag = false
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          console.log(that.listData)
          //   if(that.listData.length==1){
          //   that.master.cumulativePay = parseInt(that.master.monthPay)
          //  }else{
          //   that.master.cumulativePay=parseInt(that.master.monthPay) + parseInt(that.listData[1].cumulativePay)
          //   }
          myHttp.createOrUpdateWis(this.master).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('保存成功')
              // that.isAddFlag = false
              that.getData()
              that.isAddFlag = false
              that.master = {
                id: '',
                projectId: '',
                nowMonthInvestment: '', //Y 本月投资进度
                nowMonthPay: '', //Y 本月支付金额
                nowMonthPaySalary: '',
              }
              // this
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
      } else {
        this.master = {
          id: row.id,
          month: row.month,
          projectId: row.projectId,
          nowMonthInvestment: row.nowMonthInvestment,
          nowMonthPay: row.nowMonthPay,
          nowMonthPaySalary: row.nowMonthPaySalary,
          totalMonthInvestment: row.totalMonthInvestment,
          totalMonthPaySalary: row.totalMonthPaySalary,
          totalMonthPay: row.totalMonthPay,
        }
        row.isSet = true
      }
    },
    // 删除
    delChange(row, index, cg) {
      var that = this

      //for (let i of this.master) {
      if (
        (this.master.id != '' && this.master.id != row.id) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }

      this.$confirm('此操作将删除该调数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp
            .deleteInfoWis({
              id: row.id,
              updateBy: util.session.get('user').id,
              projectId: row.projectId,
            })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch((err) => {})
    },
    watchInput(e) {
      this.projectName = e
      this.doFilter()
    },
    //
    changeType() {},
    addFun() {
      var token = this.$store.state.token
      var entId = this.groupId
      var projectName = this.projectName
      var projectId = this.projectId
      var month = this.month
      // console.log(projectType)
      window.open(
        myHttp.exportProjectSettlementList +
          '?entId=' +
          entId +
          '&projectName=' +
          projectName +
          '&month=' +
          month +
          '&projectId=' +
          projectId +
          '&accessToken=' +
          token
      )
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // setMoney(index) {
    //   if(index==1){
    //     this.isTotal=false
    //   }else{
    //    this.isTotal=true
    //      var that = this
    //   // setUpTotal
    //   myHttp
    //     .setUpTotal({
    //       entId: this.groupId,
    //       totalValue: this.totalValue_view,
    //       projectId: this.projectId,
    //     })
    //     .then(function (resp) {
    //       if (resp.data.code == '200') {
    //         that.$message.success('设置成功')
    //         that.getMoney()
    //         that.getData()
    //       }
    //     })
    //   }

    // },
    // 总产值回显
    // getMoney() {
    //   var that = this
    //   // setUpTotal
    //   myHttp
    //     .totalInformation({
    //       projectId: this.groupId,
    //     })
    //     .then(function (resp) {
    //       if (resp.data.code == '200') {
    //         if (resp.data.data) {
    //           that.totalValue_view = resp.data.data.totalValue
    //           that.totalId = resp.data.data.totalId
    //           that.entId = resp.data.data.entId
    //           console.log(that.totalId, that.entId)
    //           that.getData()
    //         } else {
    //           that.totalValue_view = ''
    //           that.totalId = ''
    //           that.dataText = '暂无数据'
    //         }
    //       }
    //     })
    // },
    getValue(e) {
      this.master.monthPay = e
      console.log(this.master.monthPay)
      console.log(e)
    },
    //点击树形结构
    handleNodeClick(data) {
      console.log(data)
      this.entId = data.entId
      this.getData()
    },
     //获取合同价等
        getMoney(){
            var that = this
            myHttp.getEntProjectConfig({
                projectId:this.groupId,
                entId:this.entId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data.wisdomForm
                    if(data){
                        that.money = data
                    }
                }
            })
        },

        //编辑合同价等数据
        saveMoney(){
            var that = this
            myHttp.createOrUpdateInfo({
                projectId:this.groupId,
                entId:this.entId,
                beginningAppraisal:this.money.beginningAppraisal,
                endAppraisal:this.money.endAppraisal,
                cashContract:this.money.cashContract,
                createBy:util.session.get('user').id
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('保存成功')
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },
  },
}
</script>
<style scoped>
/* .contain {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 1%;
} */
.header-box {
  padding: 15px 20px;
  height: 70px;
  width: 100%;
  box-shadow: 1px 2px 3px 2px #ddd;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  text-align: left;
}
.box {
  /* margin-top: 15px; */
  width: 86%;
 
}
.box-left{
  width: 13%;
  background: #fff;
}
.box-content {
  width: 100%;
  height: calc(100% - 12vh);
  background: #fff;
}
.box-content-item {
  width: 100%;
  background: #fff;
  min-height: 200px;
  margin-top: 6px;
  display: flex;
  align-content: center;
  align-items: center;
  box-sizing: border-box;
}
.box-content-item .cell {
  width: 33%;
  padding-left: 50px;
  text-align: left;
}
.box-content-item .row {
  width: 100%;
}
.box-content-item .row .warning {
  color: red;
}
.wrap {
  display: flex;
  flex-wrap: wrap;
}
.build-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 6vh;
  background: #fff;
  border-bottom: 3px solid #f5f5f5;
  padding: 0 20px;
  justify-content: space-between;
}
/* 字体颜色 */
.font-color1 {
  color: #ffbc01;
}
.font-color2 {
  color: #0085ff;
}
.upload-demo {
  margin: 0 20px;
}
</style>
<style>
.build-bar span {
  margin-left: 0;
}
.el-table td,
.el-table th {
  text-align: center;
}
.el-pagination {
  background: #fff;
  padding: 15px 0;
}
.build-bar > .el-button--success {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.el-image .el-icon-circle-close {
  color: #fff;
}
.box-body{
  display: flex;
  width: 100%;
 height: calc(100% - 2vh);
 justify-content: space-between
}
/* .wageLedger .el-button {
  color: #fff;
  background: #1890ff;
} */
.el-tree-node{
  padding: 1vh;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
}
</style>
<style>
@import '../../assets/css/common.css';
</style>